<ng-template #courtshipModal let-d="dismiss">
  <form #courtshipForm="ngForm" [class.submitted]="courtshipForm.submitted" (ngSubmit)="submit()" novalidate>
    <!--Header-->
    <div class="modal-header">
      <h4 class="modal-title">Update Courtship</h4>
    </div>

    <!--Body-->
    <div class="modal-body">
      <div class="courtship-modal-body-text">Please update or affirm this company's courtship to post an overview note:</div>
      <div class="courtship-modal-selector-container notes-filter-radio-group mt-2">
        <div *ngFor="let courtshipType of courtshipList">
          <input id="{{courtshipType}}" type="radio" name="courtship" value="{{courtshipType}}" [(ngModel)]="selectedCourtship" required>
          <label class="text-transform-none" for="{{courtshipType}}" [ngClass]="{ 'bold': currentCourtship === courtshipType }">
            {{ CourtshipTypeLabels[courtshipType] }} <span *ngIf="currentCourtship === courtshipType">(current, affirm)</span>
          </label>
        </div>
      </div>
    </div>

    <!--Footer-->
    <div class="modal-footer">
      <button type="button" class="btn btn-default mr-3" (click)="d()">{{"GENERICS.CANCEL" | translate}}</button>
      <button type="submit" class="btn btn-primary" [disabled]="!courtshipForm.valid">{{"FORMS.POST" | translate}}</button>
    </div>
  </form>
</ng-template>
